<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width="16"
		height="16"
		aria-hidden="true">
		<path fill="none" stroke="#00abef" d="m14.2 5.8-8.4 8.4c-.7.7-1.7.7-2.3 0l-1.7-1.7c-.7-.7-.7-1.7 0-2.3l8.4-8.4c.7-.7 1.7-.7 2.3 0l1.7 1.7c.7.7.7 1.7 0 2.3h0ZM5 7l1.3 1.3M7 5l1.3 1.3M9 3l1.3 1.3M3 9l1.3 1.3"/>
	</svg>
</template>